import { updateAccount } from '../accounts'
import { updateAccountDocument } from '../accountDocument'
import { updateCall } from '../calls'
import { updateCase } from '../cases'
import { updateCaseNote } from '../caseNote'
import { updateCaseDocument } from '../caseDocument'
import { updateCaseType } from '../selectLists/caseTypes'
import { updateServiceRequest } from '../serviceRequests'
import { updateServiceRequestNote } from '../serviceRequestNote'
import { updateServiceRequestDocument } from '../serviceRequestDocument'
import { updateServiceRequestType } from '../selectLists/serviceRequestTypes'
import { updateCompany } from '../companies'
import { updateCompanyContact } from '../companyContacts'
import { updateCompanyContactRole } from '../selectLists/companyContactRoles'
import { updateCompanyLastSelectedState } from '../companyLastSelectedState'
import { updateCompanyMasterService } from '../companyMasterServices'
import { updateCompanyMSContact } from '../companyMSContacts'
import { updateCompanyMSService } from '../companyMSServices'
import { updateCompanyMSTeamMember } from '../companyMSTeamMembers'
import { updateCompanyTeamMember } from '../companyTeamMembers'
import { updateContract } from '../contracts'
import { updateCompanyDocument } from '../companyDocument'
import { updateCompanyMSDocument } from '../companyMSDocument'
import { updateCompanyMSServiceDocument } from '../companyMSServiceDocument'
import { updateContractDocument } from '../contractDocument'
import { updateEmail } from '../emails'
import {
  updateFieldSetField,
  updateFieldSetFieldSeqNums,
} from '../fieldSetFields'
import { updateFieldSet } from '../fieldSets'
import { updateGroup } from '../groups'
import { updateIndustry } from '../selectLists/industries'
import { updateLeadSourceCampaign } from '../selectLists/leadSourceCampaigns'
import { updateLeadSourceContact } from '../selectLists/leadSourceContacts'
import { updateLeadSourceEvent } from '../selectLists/leadSourceEvents'
import { updateLocation } from '../locations'
import { updateLocationDocument } from '../locationDocument'
import { updateLocationHardwareCompanyOwnedItem } from '../locationHardwareCompanyOwnedItems'
import { updateLocationHardwareTenantOwnedItem } from '../locationHardwareTenantOwnedItems'
import { updateLocationCompanyContact } from '../locationCompanyContacts'
import { updateLocationType } from '../selectLists/locationTypes'
import { updateOrder } from '../orders'
import { updateOrderContact } from '../orderContacts'
import { updateOrderLastSelectedState } from '../orderLastSelectedState'
import { updateOrderMasterService } from '../orderMasterServices'
import { updateOrderMSContact } from '../orderMSContacts'
import { updateOrderMSService } from '../orderMSServices'
import { updateOrderDocument } from '../orderDocument'
import { updateOrderMSDocument } from '../orderMSDocument'
import { updateOrderMSServiceDocument } from '../orderMSServiceDocument'
import { updateOrderMSTeamMember } from '../orderMSTeamMembers'
import { updateOrderServiceOrder } from '../orderServiceOrders'
import { updateOrderTeamMember } from '../orderTeamMembers'
import { updateMeeting } from '../meetings'
import { updateOpportunity } from '../opportunities'
import { updateOpportunityLastSelectedState } from '../opportunityLastSelectedState'
import { updateOpportunityDocument } from '../opportunityDocument'
import { updateOpportunityMSDocument } from '../opportunityMSDocument'
import { updateOpportunityMSServiceDocument } from '../opportunityMSServiceDocument'
import { updateOpportunityNote } from '../opportunityNote'
import { updateOpportunityMSNote } from '../opportunityMSNote'
import { updateOpportunityMSServiceNote } from '../opportunityMSServiceNote'
import { updateCompanyNote } from '../companyNote'
import { updateCompanyMSNote } from '../companyMSNote'
import { updateCompanyMSServiceNote } from '../companyMSServiceNote'
import { updateOrderNote } from '../orderNote'
import { updateOrderMSNote } from '../orderMSNote'
import { updateOrderMSServiceNote } from '../orderMSServiceNote'
import { updateLocationNote } from '../locationNote'
import { updateSupplierNote } from '../supplierNote'
import { updateSupplierProductNote } from '../supplierProductNote'
import { updateTsdNote } from '../tsdNote'
import { updateAccountNote } from '../accountNote'
import { updateContractNote } from '../contractNote'
import { updateOpportunityMasterService } from '../opportunityMasterServices'
import { updateOpportunityMSService } from '../opportunityMSServices'
import { updateOpportunityRegistration } from '../opportunityRegistration'
import { updateOpportunityTeamMember } from '../opportunityTeamMembers'
import { updateOpportunityMSTeamMember } from '../opportunityMSTeamMembers'
import { updateOpportunityContact } from '../opportunityContacts'
import { updateOpportunityMSContact } from '../opportunityMSContacts'
import {
  updateOpportunityStage,
  updateOpportunityStageSeqNums,
} from '../selectLists/opportunityStages'
import { updatePerson } from '../persons'
import { updateProject } from '../projects'
import { updateProduct } from '../products'
import { updateProductCategory } from '../productCategories'
import { updateProductGroup } from '../productGroups'
import { updateProductSubcategory } from '../productSubcategories'
import { updateProductKitItem } from '../productKitItems'
import { updateSubindustry } from '../selectLists/subindustries'
import { updateSupplier } from '../suppliers'
import { updateSupplierLastSelectedState } from '../supplierLastSelectedState'
import { updateSupplierContact } from '../supplierContacts'
import { updateSupplierContactRole } from '../selectLists/supplierContactRoles'
import { updateSupplierDocument } from '../supplierDocument'
import {
  updateSupplierProduct,
  updateSupplierProductSeqNums,
} from '../supplierProducts'
import { updateSupplierProductDocument } from '../supplierProductDocument'
import {
  updateSupplierProductItem,
  updateSupplierProductItemSeqNums,
} from '../supplierProductItems'
import { updateSupplierResource } from '../supplierResources'
import { updateTask } from '../task'
import { updateTeamMember } from '../teamMembers'
import { updateTeamMemberLastSelectedState } from '../teamMemberLastSelectedState'
import { updateTsd } from '../tsds'
import { updateTsdContact } from '../tsdContacts'
import { updateTsdContactRole } from '../selectLists/tsdContactRoles'
import { updateTsdDocument } from '../tsdDocument'
import { updateTsdSupplier } from '../tsdSuppliers'
import { updateTsdResource } from '../tsdResources'
import { updateUser } from '../users'
import type { TEntityId } from '~/types/models'

interface UpdateEntityNamedArgs {
  entityName: string
  updatedEntityData: any // Only changed properties
  entityId: TEntityId
}

export async function updateEntity({
  entityName,
  updatedEntityData,
  entityId,
}: UpdateEntityNamedArgs) {
  switch (entityName) {
    case 'account':
      return await updateAccount(updatedEntityData, entityId)
    case 'accountDocument':
      return await updateAccountDocument(updatedEntityData, entityId)

    case 'call':
      return await updateCall(updatedEntityData, entityId)

    case 'case':
      return await updateCase(updatedEntityData, entityId)
    case 'caseDocument':
      return await updateCaseDocument(updatedEntityData, entityId)
    case 'caseNote':
      return await updateCaseNote(updatedEntityData, entityId)
    case 'caseType':
      return await updateCaseType(updatedEntityData, entityId)

    // Forked from the case* entries above (`cases-pre-sr-fork`).
    case 'serviceRequest':
      return await updateServiceRequest(updatedEntityData, entityId)
    case 'serviceRequestDocument':
      return await updateServiceRequestDocument(updatedEntityData, entityId)
    case 'serviceRequestNote':
      return await updateServiceRequestNote(updatedEntityData, entityId)
    case 'serviceRequestType':
      return await updateServiceRequestType(updatedEntityData, entityId)

    case 'company':
      return await updateCompany(updatedEntityData, entityId)
    case 'companyContact':
      return await updateCompanyContact(updatedEntityData, entityId)
    case 'companyContactRole':
      return await updateCompanyContactRole(updatedEntityData, entityId)
    case 'companyDocument':
      return await updateCompanyDocument(updatedEntityData, entityId)
    case 'companyLastSelectedState':
      return await updateCompanyLastSelectedState(updatedEntityData, entityId)
    case 'companyMasterService':
      return await updateCompanyMasterService(updatedEntityData, entityId)
    case 'companyMSContact':
      return await updateCompanyMSContact(updatedEntityData, entityId)
    case 'companyMSDocument':
      return await updateCompanyMSDocument(updatedEntityData, entityId)
    case 'companyMSService':
      return await updateCompanyMSService(updatedEntityData, entityId)
    case 'companyMSServiceDocument':
      return await updateCompanyMSServiceDocument(updatedEntityData, entityId)
    case 'companyMSTeamMember':
      return await updateCompanyMSTeamMember(updatedEntityData, entityId)
    case 'companyTeamMember':
      return await updateCompanyTeamMember(updatedEntityData, entityId)

    case 'contract':
      return await updateContract(updatedEntityData, entityId)
    case 'contractDocument':
      return await updateContractDocument(updatedEntityData, entityId)

    case 'email':
      return await updateEmail(updatedEntityData, entityId)

    case 'fieldSet':
      return await updateFieldSet(updatedEntityData, entityId)
    case 'fieldSetField':
      return await updateFieldSetField(updatedEntityData, entityId)
    case 'fieldSetFieldSeqNums':
      return await updateFieldSetFieldSeqNums(updatedEntityData)

    case 'group':
      return await updateGroup(updatedEntityData, entityId)

    case 'industry':
      return await updateIndustry(updatedEntityData, entityId)

    case 'leadSourceCampaign':
      return await updateLeadSourceCampaign(updatedEntityData, entityId)
    case 'leadSourceContact':
      return await updateLeadSourceContact(updatedEntityData, entityId)
    case 'leadSourceEvent':
      return await updateLeadSourceEvent(updatedEntityData, entityId)

    case 'location':
      return await updateLocation(updatedEntityData, entityId)
    case 'locationDocument':
      return await updateLocationDocument(updatedEntityData, entityId)
    case 'locationHardwareCompanyOwnedItem':
      return await updateLocationHardwareCompanyOwnedItem(
        updatedEntityData,
        entityId
      )
    case 'locationHardwareTenantOwnedItem':
      return await updateLocationHardwareTenantOwnedItem(
        updatedEntityData,
        entityId
      )
    case 'locationCompanyContact':
      return await updateLocationCompanyContact(updatedEntityData, entityId)
    case 'locationType':
      return await updateLocationType(updatedEntityData, entityId)

    case 'order':
      return await updateOrder(updatedEntityData, entityId)
    case 'orderContact':
      return await updateOrderContact(updatedEntityData, entityId)
    case 'orderDocument':
      return await updateOrderDocument(updatedEntityData, entityId)
    case 'orderLastSelectedState':
      return await updateOrderLastSelectedState(updatedEntityData, entityId)
    case 'orderMasterService':
      return await updateOrderMasterService(updatedEntityData, entityId)
    case 'orderMSContact':
      return await updateOrderMSContact(updatedEntityData, entityId)
    case 'orderMSDocument':
      return await updateOrderMSDocument(updatedEntityData, entityId)
    case 'orderMSService':
      return await updateOrderMSService(updatedEntityData, entityId)
    case 'orderMSServiceDocument':
      return await updateOrderMSServiceDocument(updatedEntityData, entityId)
    case 'orderMSTeamMember':
      return await updateOrderMSTeamMember(updatedEntityData, entityId)
    case 'orderServiceOrder':
      return await updateOrderServiceOrder(updatedEntityData, entityId)
    case 'orderTeamMember':
      return await updateOrderTeamMember(updatedEntityData, entityId)

    case 'meeting':
      return await updateMeeting(updatedEntityData, entityId)

    case 'opportunity':
      return await updateOpportunity(updatedEntityData, entityId)
    case 'opportunityContact':
      return await updateOpportunityContact(updatedEntityData, entityId)
    case 'opportunityDocument':
      return await updateOpportunityDocument(updatedEntityData, entityId)
    case 'opportunityNote':
      return await updateOpportunityNote(updatedEntityData, entityId)
    case 'opportunityMSNote':
      return await updateOpportunityMSNote(updatedEntityData, entityId)
    case 'opportunityMSServiceNote':
      return await updateOpportunityMSServiceNote(updatedEntityData, entityId)
    case 'companyNote':
      return await updateCompanyNote(updatedEntityData, entityId)
    case 'companyMSNote':
      return await updateCompanyMSNote(updatedEntityData, entityId)
    case 'companyMSServiceNote':
      return await updateCompanyMSServiceNote(updatedEntityData, entityId)
    case 'orderNote':
      return await updateOrderNote(updatedEntityData, entityId)
    case 'orderMSNote':
      return await updateOrderMSNote(updatedEntityData, entityId)
    case 'orderMSServiceNote':
      return await updateOrderMSServiceNote(updatedEntityData, entityId)
    case 'locationNote':
      return await updateLocationNote(updatedEntityData, entityId)
    case 'supplierNote':
      return await updateSupplierNote(updatedEntityData, entityId)
    case 'supplierProductNote':
      return await updateSupplierProductNote(updatedEntityData, entityId)
    case 'tsdNote':
      return await updateTsdNote(updatedEntityData, entityId)
    case 'accountNote':
      return await updateAccountNote(updatedEntityData, entityId)
    case 'contractNote':
      return await updateContractNote(updatedEntityData, entityId)
    case 'opportunityLastSelectedState':
      return await updateOpportunityLastSelectedState(
        updatedEntityData,
        entityId
      )
    case 'opportunityMasterService':
      return await updateOpportunityMasterService(updatedEntityData, entityId)
    case 'opportunityMSContact':
      return await updateOpportunityMSContact(updatedEntityData, entityId)
    case 'opportunityMSDocument':
      return await updateOpportunityMSDocument(updatedEntityData, entityId)
    case 'opportunityMSService':
      return await updateOpportunityMSService(updatedEntityData, entityId)
    case 'opportunityMSServiceDocument':
      return await updateOpportunityMSServiceDocument(
        updatedEntityData,
        entityId
      )
    case 'opportunityMSTeamMember':
      return await updateOpportunityMSTeamMember(updatedEntityData, entityId)

    case 'opportunityRegistration':
      return await updateOpportunityRegistration(updatedEntityData, entityId)
    case 'opportunityTeamMember':
      return await updateOpportunityTeamMember(updatedEntityData, entityId)
    case 'opportunityStage':
      return await updateOpportunityStage(updatedEntityData, entityId)
    case 'opportunityStageSeqNums':
      return await updateOpportunityStageSeqNums(updatedEntityData)

    case 'person':
      return await updatePerson(updatedEntityData, entityId)

    case 'project':
      return await updateProject(updatedEntityData, entityId)

    case 'productKitItem':
      return await updateProductKitItem(updatedEntityData, entityId)
    case 'product':
      return await updateProduct(updatedEntityData, entityId)
    case 'productCategory':
      return await updateProductCategory(updatedEntityData, entityId)
    case 'productGroup':
      return await updateProductGroup(updatedEntityData, entityId)
    case 'productSubcategory':
      return await updateProductSubcategory(updatedEntityData, entityId)

    case 'subindustry':
      return await updateSubindustry(updatedEntityData, entityId)

    case 'supplier':
      return await updateSupplier(updatedEntityData, entityId)
    case 'supplierLastSelectedState':
      return await updateSupplierLastSelectedState(updatedEntityData, entityId)
    case 'supplierContact':
      return await updateSupplierContact(updatedEntityData, entityId)
    case 'supplierContactRole':
      return await updateSupplierContactRole(updatedEntityData, entityId)
    case 'supplierDocument':
      return await updateSupplierDocument(updatedEntityData, entityId)
    case 'supplierProduct':
      return await updateSupplierProduct(updatedEntityData, entityId)
    case 'supplierProductDocument':
      return await updateSupplierProductDocument(updatedEntityData, entityId)
    case 'supplierProductSeqNums':
      return await updateSupplierProductSeqNums(updatedEntityData)
    case 'supplierProductItem':
      return await updateSupplierProductItem(updatedEntityData, entityId)
    case 'supplierProductItemSeqNums':
      return await updateSupplierProductItemSeqNums(updatedEntityData)
    case 'supplierResource':
      return await updateSupplierResource(updatedEntityData, entityId)

    case 'task':
      return await updateTask(updatedEntityData, entityId)

    case 'teamMember':
      return await updateTeamMember(updatedEntityData, entityId)
    case 'teamMemberLastSelectedState':
      return await updateTeamMemberLastSelectedState(
        updatedEntityData,
        entityId
      )

    case 'tsd':
      return await updateTsd(updatedEntityData, entityId)
    case 'tsdContact':
      return await updateTsdContact(updatedEntityData, entityId)
    case 'tsdContactRole':
      return await updateTsdContactRole(updatedEntityData, entityId)
    case 'tsdDocument':
      return await updateTsdDocument(updatedEntityData, entityId)
    case 'tsdSupplier':
      return await updateTsdSupplier(updatedEntityData, entityId)
    case 'tsdResource':
      return await updateTsdResource(updatedEntityData, entityId)

    case 'user':
      return await updateUser(updatedEntityData, entityId)
    default:
      throw new Error(
        `[services/crud/updateEntity] updateEntity | Unknown entityName '${entityName}'`
      )
  }
}
